import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './Header';
import styles from './PingZeRegulatedJueju.module.css';

import FiveWord from './FiveWord.jpg';
import SevenWord from './SevenWord.jpg';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

function PingZeRegulatedJueju() {
  // ===== UI (Gongshi style) =====
  const [isFiveWordLine, setIsFiveWordLine] = useState(true);
  const [isZeStart, setIsZeStart] = useState(true);
  const [poemUnits, setPoemUnits] = useState(Array(20).fill(''));
  const [submittedPoem, setSubmittedPoem] = useState('');
  const [placeholderText, setPlaceholderText] = useState('');
  const placeholderContent = 'Type here...';

  // ===== Ping/Ze assess logic (KEEP SAME as PingZeAssess poem) =====
  const [pingZeFeedback, setPingZeFeedback] = useState('');
  const [modelAssessment, setModelAssessment] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    if (!poemUnits[0]) {
      let index = 0;
      const interval = setInterval(() => {
        setPlaceholderText(placeholderContent.substring(0, index));
        index = (index + 1) % (placeholderContent.length + 1);
      }, 200);
      return () => clearInterval(interval);
    }
  }, [poemUnits]);

  const handleToggle = () => {
    setIsFiveWordLine((prev) => !prev);
    setPoemUnits(Array(!isFiveWordLine ? 20 : 28).fill(''));
  };

  const handleInputChange = (index, value) => {
    const next = [...poemUnits];
    next[index] = value;
    setPoemUnits(next);
  };

  // ===== Gongshi-style pattern UI =====
  const renderPoemInputs = () => {
    const lineUnits = isFiveWordLine ? 5 : 7;
    const totalLines = 4;

    const fiveWordPingStart = [
      '○/●', '○', '○/●', '●', '○',
      '○/●', '●', '○/●', '○', '○',
      '○/●', '●', '○/●', '○', '●',
      '○/●', '○', '○/●', '●', '○'
    ];

    const fiveWordZeStart = [
      '○/●', '●', '○/●', '○', '○',
      '○/●', '○', '○/●', '●', '○',
      '○/●', '○', '○/●', '●', '●',
      '○/●', '●', '○/●', '○', '○'
    ];

    const sevenWordPingStart = [
      '○/●', '○', '○/●', '●', '○/●', '○', '○',
      '○/●', '●', '○/●', '○', '○/●', '●', '○',
      '○/●', '●', '○/●', '○', '○/●', '●', '●',
      '○/●', '○', '○/●', '●', '○/●', '○', '○'
    ];

    const sevenWordZeStart = [
      '○/●', '●', '○/●', '○', '○/●', '●', '○',
      '○/●', '○', '○/●', '●', '○/●', '○', '○',
      '○/●', '○', '○/●', '●', '○/●', '○', '●',
      '○/●', '●', '○/●', '○', '○/●', '●', '○'
    ];

    const patternArray = isFiveWordLine
      ? (isZeStart ? fiveWordZeStart : fiveWordPingStart)
      : (isZeStart ? sevenWordZeStart : sevenWordPingStart);

    const lineBreaks = [];
    for (let i = 0; i < totalLines; i++) {
      const units = [];
      for (let j = 0; j < lineUnits; j++) {
        const index = i * lineUnits + j;

        units.push(
          <div key={`unit-${i}-${j}`} className={styles.unitContainer}>
            <div className={styles.symbolWrapper}>
              {patternArray[index]?.includes('/') ? (
                <>
                  <div className={styles.toneCircleRow}>
                    {patternArray[index].split('/').map((tone, k) => (
                      <div
                        key={k}
                        className={`${styles.toneCircle} ${tone === '●' ? styles.ze : styles.ping}`}
                      />
                    ))}
                  </div>
                  <div className={styles.toneLabel}>Ping / Ze</div>
                </>
              ) : (
                <>
                  <div
                    className={`${styles.toneCircle} ${patternArray[index] === '●' ? styles.ze : styles.ping}`}
                  />
                  <div className={styles.toneLabel}>
                    {patternArray[index] === '●' ? 'Ze' : 'Ping'}
                  </div>
                </>
              )}
            </div>

            <input
              type="text"
              value={poemUnits[index] || ''}
              onChange={(e) => handleInputChange(index, e.target.value)}
              className={styles.unitBox}
              placeholder={index === 0 ? placeholderText : ''}
              onFocus={() => index === 0 && setPlaceholderText('')}
            />
          </div>
        );

        if (isFiveWordLine && j === 1) {
          units.push(<div key={`gap-${i}-${j}`} className={styles.gap} />);
        } else if (!isFiveWordLine && (j === 1 || j === 3)) {
          units.push(<div key={`gap-${i}-${j}`} className={styles.gap} />);
        }
      }

      lineBreaks.push(
        <div key={`line-${i}`} className={styles.line}>
          {units}
        </div>
      );
    }

    return lineBreaks;
  };

  const formatPoem = () => {
    const lineUnits = isFiveWordLine ? 5 : 7;
    const totalLines = 4;
    let poem = '';

    for (let i = 0; i < totalLines; i++) {
      const line = poemUnits.slice(i * lineUnits, (i + 1) * lineUnits).join(' ').trim();
      poem += line + '\n';
    }
    return poem.trim();
  };

  // ===== Submit logic (KEEP SAME as PingZeAssess poem) =====
  const handleSubmit = async () => {
    const poemText = submittedPoem.trim() || formatPoem();

    if (!poemText) {
      setError('Please enter your poem before submitting.');
      return;
    }

    setLoading(true);
    setPingZeFeedback('');
    setModelAssessment('');
    setError(null);
    setIsValid(null);

    const endpoint = '/assess-poem';
    const payload = {
      poem: poemText,
      user_level: 'guest',
      level: 'gongshi',
    };

    try {
      const response = await axios.post(`${API_URL}${endpoint}`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      setIsValid(response.data.is_valid);
      setPingZeFeedback(response.data.ping_ze_feedback || '');
      setModelAssessment(response.data.model_assessment || '');
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred while processing your submission.');
    }

    setLoading(false);
  };

  const handleClear = () => {
    setSubmittedPoem('');
    setIsFiveWordLine(true);
    setIsZeStart(true);
    setPoemUnits(Array(20).fill(''));
    setPingZeFeedback('');
    setError(null);
    setLoading(false);
    setIsValid(null);
  };

  return (
    <div>
      <Header />

      <div className={styles.pageOffset}>
        <div className={styles.container}>
          <h2>Regulated Jueju (Ping/Ze)</h2>

          {/* images row (same as Gongshi) */}
          <div className={styles.imageRow}>
            <img src={FiveWord} alt="Five word pattern" className={styles.PingzeImage} />
            <img src={SevenWord} alt="Seven word pattern" className={styles.PingzeImage} />
          </div>

          {/* toggles (same layout as Gongshi) */}
          <div className={styles.verticalToggles}>
            <div className={styles.toggleRow}>
              <span className={styles.toggleLabel}>
                {isFiveWordLine ? '5-word per line' : '7-word per line'}
              </span>
              <label className={styles.switch}>
                <input type="checkbox" checked={!isFiveWordLine} onChange={handleToggle} />
                <span className={`${styles.slider} ${styles.round}`} />
              </label>
            </div>

            <div className={styles.toggleRow}>
              <span className={styles.toggleLabel}>{isZeStart ? 'Ze Start' : 'Ping Start'}</span>
              <label className={styles.switch}>
                <input
                  type="checkbox"
                  checked={!isZeStart}
                  onChange={() => setIsZeStart((prev) => !prev)}
                />
                <span className={`${styles.slider} ${styles.round}`} />
              </label>
            </div>
          </div>

          <p>Type in unit by unit:</p>
          {renderPoemInputs()}

          <p>OR</p>
          <p>Drop your whole poem</p>
          <textarea
            placeholder={"Enter your poem here...\n\nNote: Please remove all punctuation from your poem including apostrophes!"}
            value={submittedPoem}
            onChange={(e) => setSubmittedPoem(e.target.value)}
            className={styles.textArea}
          />

          <div className={styles.submitBtnContainer}>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className={styles.button}
            >
              {loading ? 'Checking...' : 'Submit'}
            </button>

            <button
              onClick={handleClear}
              disabled={loading}
              className={styles.button}
            >
              Clear
            </button>
          </div>

          {loading && <div className={styles.loader} />}
          {error && <div className={styles.errorMessage}>{error}</div>}

          {pingZeFeedback && (
            <div className={styles.pingZeFeedback}>
              <h4>Ping/Ze Feedback</h4>
              {pingZeFeedback.split('\n').map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>
          )}

          {modelAssessment && isValid && (
            <div className={styles.pingZeFeedback}>
              <h4>Model Assessment</h4>
              <p>{modelAssessment}</p>
            </div>
          )}
          
        </div>
      </div>
    </div>
  );
}

export default PingZeRegulatedJueju;
